import { css } from 'linaria';

export const kitchenGallerySectionTabs = css`
  && {
    margin-bottom: 32px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const kitchenGalleryNeoStyle = css`
  && {
    grid-template-rows: 462px 266px auto;

    @media (--only-desktop) {
      grid-template-rows: 391px 207px auto;
    }

    @media (--only-tablet) {
      grid-template-rows: 290px 138px auto;
    }

    @media (--only-mobile) {
      grid-template-rows: 302px auto;
    }

    @media (--from-tablet) {
      :nth-child(3) {
        grid-row: unset
      }
    }
  }
`;

export const kitchenGallerySectionMoreBtn = css`
  && {
    display: block;
    margin: 0 auto;

    @media (--only-mobile) {
      width: 100%;
      border-radius: var(--rounding-m);
    }
  }
`;
